module.exports = __webpack_public_path__ + "img/setting_19.9c8f7cc7.svg";